/**
 * Overlay Dark Souls — consulta fora do território do portfólio.
 */
export class YouDied {
  /**
   * @param {HTMLElement} root
   */
  constructor(root) {
    this.root = root;
    this.root.hidden = true;
    this.root.setAttribute('aria-live', 'assertive');
  }

  /**
   * @param {{ query?: string }} [meta]
   */
  show(meta = {}) {
    this.root.hidden = false;
    this.root.dataset.state = 'you-died';
    const q = String(meta.query ?? '').trim();

    this.root.innerHTML = `
      <div class="you-died" role="alertdialog" aria-labelledby="you-died-title" aria-describedby="you-died-sub">
        <div class="you-died__veil" aria-hidden="true"></div>
        <div class="you-died__inner">
          <p class="you-died__kicker">Fora do território</p>
          <h2 class="you-died__title" id="you-died-title">YOU DIED</h2>
          <p class="you-died__sub" id="you-died-sub">
            Esta pergunta não habita o universo deste portfólio.
            Volte à fogueira e tente uma intenção alinhada a dados, analytics ou liderança técnica.
          </p>
          ${
            q
              ? `<p class="you-died__query">“${escapeHtml(q)}”</p>`
              : ''
          }
          <button type="button" class="you-died__bonfire" id="you-died-reset">
            Acender fogueira
          </button>
        </div>
      </div>
    `;

    this.root.querySelector('#you-died-reset')?.addEventListener('click', () => {
      this.root.dispatchEvent(new CustomEvent('board:reset', { bubbles: true }));
    });

    requestAnimationFrame(() => {
      this.root.querySelector('.you-died')?.classList.add('is-revealed');
    });
  }

  hide() {
    this.root.hidden = true;
    this.root.innerHTML = '';
    this.root.dataset.state = '';
  }
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
